import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { addToCart } from '../Actions/OrderScanning.action';
import { translate } from '../Services/translation';
import constants from '../constants';

class OrderScanningContainer extends Component {

    constructor(props) {
        super(props);
        //this.state = { ...props };
        this.state = {
            ...props,
            selectedTabIndex: 0,
        };
    }

    componentDidMount() {

    }

    addArticlesToCart() {
        this.props.addToCart(this.props.genericGridView.dataRows, constants.checkoutUrl);
    }

    showOkArticles(index) {
        document.getElementById('missingVariants').style.display = 'none';
        document.getElementById('errorInFile').style.display = 'none';
        document.getElementById('order-scanning-variants').style.display = '';
        this.setState({ selectedTabIndex: index });
    }

    showMissingVariants(index) {
        document.getElementById('missingVariants').style.display = '';
        document.getElementById('errorInFile').style.display = 'none';
        document.getElementById('order-scanning-variants').style.display = 'none';
        this.setState({ selectedTabIndex: index });
    }

    showErrorInFiles(index) {
        document.getElementById('missingVariants').style.display = 'none';
        document.getElementById('errorInFile').style.display = '';
        document.getElementById('order-scanning-variants').style.display = 'none';
        this.setState({ selectedTabIndex: index });
    }

    getGridViewContainer() {
        let genericGridViewContainerEl = document.querySelector('[data-grid-view="OrderScanning"]');
        let orderScanningGridView = document.getElementById('order-scanning-variants');
        if (genericGridViewContainerEl != null && orderScanningGridView != null) {
            orderScanningGridView.appendChild(genericGridViewContainerEl);
        }

    }

    render() {
        const { missingVariants } = this.props.orderScanning;
        const { errorInFileVariants } = this.props.orderScanning;
        const { wrongWareHouse } = this.props.orderScanning;
        let { successfulVariantCount } = this.props.orderScanning;

        // If empty set value to 0
        successfulVariantCount = successfulVariantCount || 0;

        return (
            <Fragment>
                {wrongWareHouse && <div className="error">{translate('common.orderscanning.title.warehouseerror')} <i class="fas fa-exclamation-circle error"></i></div>}
                {successfulVariantCount>0 && !wrongWareHouse &&
                    <div className="orderscanning__carry-on-container"><button className="button carry-on" onClick={() => this.addArticlesToCart()}>{translate('common.orderscanning.title.gotocart')} <i class="fas fa-arrow-right"></i></button></div>
                }

                <section className="order-scanning-tab-wrapper">
                    <nav className="tab__header-container">
                        <ul>
                            <li className={`tab__header ${this.state.selectedTabIndex === 0 ? "tab__header--active" : ""}`} onClick={() => this.showOkArticles(0)}>
                                {translate('common.orderscanning.title.scanned.articles')} ({ successfulVariantCount })
                            </li>
                            {missingVariants && missingVariants.length > 0 &&
                                <li className={`tab__header tab__header-error ${this.state.selectedTabIndex === 1 ? "tab__header-error--active" : ""}`} onClick={() => this.showMissingVariants(1)}>
                                    {translate('common.orderscanning.title.no.relation')} ({missingVariants.length})
                                </li>}
                            {errorInFileVariants && errorInFileVariants.length > 0 &&
                                <li className={`tab__header tab__header-error ${this.state.selectedTabIndex === 2 ? "tab__header-error--active" : ""}`} onClick={() => this.showErrorInFiles(2)}>
                                    {translate('common.orderscanning.title.error.data')} ({errorInFileVariants.length})
                                </li>}
                        </ul>
                    </nav>
                </section>
                {missingVariants && <div id="missingVariants" style={{ display: 'none' }}>
                    <h3>{translate('common.orderscanning.title.articles.not.read')}</h3>
                    <h4>{translate('common.orderscanning.title.no.relation')}</h4>
                    <table className="order-scanning-table">
                        <thead>
                            <tr>
                                <th><strong>{translate('common.orderscanning.title.articlenumber')}</strong></th>
                                <th><strong>{translate('common.orderscanning.title.name')}</strong></th>
                                <th><strong>{translate('common.orderscanning.title.quantity')}</strong></th>
                                <th><strong>{translate('common.orderscanning.title.unit')}</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            {missingVariants.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.customerArticleNumber}</td>
                                    <td>{item.articleName}</td>
                                    <td>{item.quantityOrderedFromCustomer}</td>
                                    <td>{item.unit}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>}
                {errorInFileVariants && <div id="errorInFile" style={{ display: 'none' }}>
                    <div>
                        <h3>{translate('common.orderscanning.title.articles.not.read')}</h3>
                        <h4>{translate('common.orderscanning.title.no.relation')}</h4>
                        <div className="row">
                            <div className="columns small-12 medium-3 item-header"><strong>{translate('common.orderscanning.title.articlenumber')}</strong></div>
                            <div className="columns small-12 medium-4 item-header"><strong>{translate('common.orderscanning.title.name')}</strong></div>
                            <div className="columns small-12 medium-2 item-header"><strong>{translate('common.orderscanning.title.quantity')}</strong></div>
                            <div className="columns small-12 medium-2 item-header"><strong>{translate('common.orderscanning.title.unit')}</strong></div>
                        </div>
                        {errorInFileVariants.map((item, index) => (
                            <div className="row" key={index}>
                                <div className="columns small-12 medium-3 item-row">{item.customerArticleNumber}</div>
                                <div className="columns small-12 medium-4 item-row">{item.articleName}</div>
                                <div className="columns small-12 medium-2 item-row">{item.quantityOrderedFromCustomer}</div>
                                <div className="columns small-12 medium-2 item-row">{item.unit}</div>
                            </div>
                        ))}
                    </div>
                </div>}
                <div id="order-scanning-variants"></div>
                {this.getGridViewContainer()}
            </Fragment >
        );
    }

    componentWillUnmount() {

    }

    componentWillUpdate() {

    }

}


const mapStateToProps = state => {
    return {
        orderScanning: state.orderScanning,
        genericGridView: state.genericGridView
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (rows, url) => dispatch(addToCart(rows, url)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderScanningContainer);
